export const TOKEN_STATUSES = {
    STOP: 'stop',
    BOOK: 'book',
    MINT_1: 'mint_1',
    MINT_2: 'mint_2',
};

export const TOKEN_STATUSES_ARRAY = Object.values(TOKEN_STATUSES);
